import React, { useContext } from 'react' 
import { Link } from 'react-router-dom'
import slugify from 'react-slugify'  
import { reportData } from '../../../data/report-data/report-data/reportData'
import { LangContext } from '../../../context/DataContext'
import UseLang from '../../../hooks/UseLang'

const TitleReport = () => {
    const {myLang} = useContext(LangContext)
    return (
        <h1>{reportData.investigacionAtaquesDdos[myLang].title}</h1>
    )
}

function InvestigacionAtaquesDdosPreview() {
    return (
        <>  
            <div id="p1" className="alerts alert_white">
                <TitleReport />
                <UseLang es> 
                    <p>Autor: Paula Venosa y Paul Bernal </p>
                    <p>Este estudio tuvo como objetivo relevar información relacionada con la ocurrencia de ataques DDoS, con el costo que estos ataques tienen para las organizaciones y también con la incorporación de técnicas y herramientas de mitigación.</p>
                     
                     
                        <Link 
                            to={`/es/ciberseguridad/${slugify(reportData.investigacionAtaquesDdos.es.title)}`} 
                            className="buttons button_blue"
                        >
                            Leer Reporte
                        </Link> 
                </UseLang>
                <UseLang en>
                    <p>Author: Paula Venosa y Paul Bernal</p>
                    <p>The purpose of this study was to gather information about the occurrence of DDoS attacks, the financial impact of these attacks for an organization, and the adoption of mitigation techniques and tools.</p>
                      
                        <Link 
                            to={`/en/cybersecurity/${slugify(reportData.investigacionAtaquesDdos.en.title)}`}
                            className="buttons button_blue"
                        >
                            Read Report
                        </Link>
                
                </UseLang>
                <UseLang pt> 
                    <p>Autor: Paula Venosa y Paul Bernal</p>
                    <p>Este estudo teve como objetivo coletar informações relacionadas à ocorrência de ataques DDoS, com o custo que estes ataques têm para as organizações e também à incorporação de técnicas e ferramentas de mitigação.</p>
             
                        <Link 
                            to={`/pt/ciberseguranca/${slugify(reportData.investigacionAtaquesDdos.pt.title)}`}
                            className="buttons button_blue"
                        >
                            Leia o Relatório
                        </Link>
                   
                </UseLang>
            </div>
        </>
    )
}

export default InvestigacionAtaquesDdosPreview